import React from 'react'
import Card from '../components/Card';
import songs from '../components/songs';
function Home(props) {
  return (
    <>
    <div className="d-flex flex-row flex-wrap">
    {
      songs.map((value,index)=>{
        return (
        <Card 
          path={value.title} 
          title={value.title} 
          artist={value.artist} 
          image={value.image} 
          key={index} index={index} 
          />
        )
      })
    }
    </div>
    </>
  )
}

export default Home